import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      links={[
        {
          key: '聚联联 G-Link',
          title: '聚联联 G-Link',
          href: '', // TODO: 添加链接
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
